import React, { useState } from "react";
import TemplateTagsTableItem from "./TemplateTagsTableItem";
import TemplateTagsTableItemMobile from "./TemplateTagsTableItemMobile";
import { isMobile } from "../../../../../../src/helpers/Mobile";

import styles from "./TemplateTagsTable.module.scss";
const TemplateTagsTable = ({
  itemTags,
  headers,
  headerClickHandler,
  handleClickTemplateTag,
  handleClickDraft,
  mapTypes
}) => {

  const [selectAll, setSelectAll] = useState(false);
  const [selected, setSelected] = useState(null);

  const handleSelectOne = (selectedNew) => {
    if (selected === selectedNew) {
      setSelected(null);
    }
    setSelectAll(false);
  };

  // let isMobile = true
  const table = (
    <div
      className={styles["template-tags-table"]}
      data-automation-id="template-tags-table"
    >
      <div className={styles["template-tags-table-header"]}>
          {Object.keys(headers).map((headerKey, index) => {
            let header = headers[headerKey]
            return (
              <div
                key={header.name}
                data-automation-id={`sort-by-${header.name}`}
                onClick={() => {
                  headerClickHandler(header.name);
                }}
                data-filter-name={header.name}
                className={`${styles["template-tags-table-header-item"]} ${styles[`table-header-${header.name}`]}`}
              >
                {header.title}{" "}
                <span
                  className={`${styles["template-tags-table-header-icon-span"]} ${
                    header.active ? styles["active"] : ""
                  }  ${header.direction ? "" : styles["down"]}`}
                >
                  {" "}
                  <i className={"icon-iconos_flecha-ordenar"}></i>
                </span>
              </div>
            );
          })}
          <div className={styles["table-header-action"]}></div>
      </div>
      <div className={styles["template-tags-table-content"]}>
        {itemTags.map((itemTag) => {
          return (
            <div className={styles["template-tags-table-content-item"]} key={itemTag.id}>
              <TemplateTagsTableItem
                itemTag={itemTag}
                isSelected={
                  selected === itemTag.id || selectAll
                }
                handleSelect={handleSelectOne}
                handleClick={handleClickTemplateTag}
                mapTypes={mapTypes}
              />
            </div>
          );
        })}
      </div>
    </div>
  );

  const tableMobile = (
    <div className={styles["template-tags-table-mobile"]} data-automation-id="product-template-tags-table">
      <div className={styles["template-tags-table-content"]}>
        {itemTags.map((itemTag) => {
          return (
            <div className={styles["template-tags-table-content-item"]} key={itemTag.id}>
              <TemplateTagsTableItemMobile
                itemTag={itemTag}
                isSelected={
                  selected === itemTag.id || selectAll
                }
                handleSelect={handleSelectOne}
                handleClick={handleClickTemplateTag}
                mapTypes={mapTypes}
              />
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <div className={styles["template-tags-table-container"]}>{isMobile ? tableMobile : table}</div>
  );
};

export default TemplateTagsTable;
